import type { SongMode } from '@/types/song';

export function formatSongKey(key: string, mode: SongMode = 'MAJOR'): string {
  if (!key) return '';
  return mode === 'MINOR' ? `${key}m` : key;
}